export function selectedcompanyuser(state = {}, action) {
    switch (action.type) {
    case 'COMPANY USER DATA':
        console.log(action.data);
        return action.data;
    default:
        return state;
    }
}
  